<template>
    <v-main class="pa-2" fluid>
        <h1>Tasks</h1>
        <v-row>
            <v-dialog v-model="dialog" @keydown.esc="dialog = false" persistent max-width="600px">
                <template v-slot:activator="{ on }">
                    <v-btn color="primary" dark v-on="on">Add new Task</v-btn>
                </template>
                <v-card color="lighten-1">
                    <v-toolbar>
                        <v-toolbar-title>
                            <span class="headline">{{formTitle}}</span>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                
                                <v-form ref="form" v-model="valid" class="row">
                                    
                                        


                                    <v-col cols="12" md="12">
                                    <v-radio-group 
                                    :rules="nameRules"
                                     class="inline-radiogroup" v-model="editedItem.type" label="Type of price">
                                        <v-radio
                                          label="Fixed"
                                          value="fixed"
                                          selected
                                        ></v-radio>
                                        <v-radio float-right
                                          label="Per hr"
                                          value="hr"
                                        ></v-radio>
                                     
                                      </v-radio-group>
                                    </v-col>
                                      <v-text-field label="Name" v-model="editedItem.name" :rules="nameRules" required></v-text-field>
                                </v-form>
                                
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                        <v-btn color="blue darken-1" type="submit" @click="save" :disabled="!valid">Save</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>

        <v-data-table
            :headers="headers"
            :items="tasks"
            :items-per-page="10"
            class="elevation-1">
                <template v-slot:item.actions="{ item }">

                <v-btn v-if="item.type != 'auto'" icon small @click="edit(item)">
                  <v-icon center>mdi-pencil</v-icon> 
                </v-btn>

                <v-btn v-if="item.type != 'auto'" icon small color="red" @click="deleteTask(item.id)">
                  <v-icon center>mdi-delete-forever</v-icon> 
                </v-btn>

                </template>
            <template v-slot:item.status="{ item }">
                    <v-switch v-if="item.type != 'auto'" :success="item.status == 1 ? true : false" @change="updateStatus(item)"
                                  v-model="item.status"
                                  inset
                                  :label="getUserSwitchLabel(item.status)"
                            ></v-switch>
                </template>

            </v-data-table>

            <v-snackbar
                v-model="snackbar"
              >
                {{ snackbartext }} 

                <template v-slot:action="{ attrs }">
                  <v-btn
                    color="orange"
                    text
                    v-bind="attrs"
                    @click="snackbar = false"
                  >
                    Close
                  </v-btn>
                </template>
              </v-snackbar>
    </v-main>
</template>

<script>
    import { mapState } from 'vuex'

    export default {
        data() {
            return {
                headers: [
                    { text: '', value: 'data-table-expand' },
                    { text: 'Name', align: 'start', sortable: true, value: 'name', },
                    { text: 'Type', align: 'start', sortable: true, value: 'type' },
                    { text: '', align: 'start', sortable: true, value: 'status' },
                    { text: '', align: 'start', sortable: true, value: 'actions' },
                ],

                dialog: false,
                snackbar : false,
                snackbartext : 'Cannot Delete this task. It is already being used',
                editedIndex: -1,
                valid: true,
                lazy: true,
                isEditing: null,
                editedItem: {
                    name : '',
                    type : 'fixed',
                    status : true,
                },
                nameRules: [
                    v => !!v || 'Required',
                ],
            }
        },

        mounted () {
            if( this.tasks.length == 0 )
            this.$store.dispatch('fetchTasks')
        },


        computed: {
            ...mapState(['tasks']),

            formTitle () {
                return this.editedIndex === -1 ? 'New Task' : 'Edit Task'
            },
        },

        watch: {
            dialog (val) {
                val || this.close()
            },
        },
        
        methods: {

            edit(item) { 

                this.editedIndex = this.tasks.indexOf(item);
                this.editedItem = Object.assign({}, item)

                this.dialog = true
            },

            close () {
                this.dialog = false
                this.$nextTick(() => {
                  this.editedItem = Object.assign({}, this.defaultItem)
                  this.editedIndex = -1
                  
                })
              },


              save () {

                if (this.editedIndex > -1) {


                    axios.put('/api/tasks/' + this.editedItem.id, this.editedItem)
                        .then( response => {

                            Object.assign(this.tasks[this.editedIndex], this.editedItem)
                            this.close();
                            
                        })
                        .catch( err => {
                            console.log( err )
                        })

                  
                } else {


                    axios.post('/api/tasks', this.editedItem)
                    .then( response => {

                        this.tasks.push(this.editedItem)

                        this.close();
                        
                    })
                    .catch( err => {
                        console.log( err )
                    })
                  
                }

              },

              updateStatus(item) {

                this.editedIndex = this.tasks.indexOf(item)
                this.editedItem = Object.assign({}, item)

                axios.put('/api/tasks/updateStatus/' + this.editedItem.id, this.editedItem)
                        .then( response => {
                            
                            this.close();
                            
                        })
                        .catch( err => {
                            console.log( err )
                        })

            },


              deleteTask(id) {

                confirm('Are you sure you want to delete this Task? This action can not be undone') && 

                axios.delete('/api/tasks/' + id)
                        .then( response => {

                            const index = this.tasks.map(function (f) { return f.id }).indexOf(id)

                            this.$store.state.tasks.splice(index, 1)
                        })
                        .catch( err => {
                            this.snackbar = true
                            console.log( err )
                        })
              }
          }
    }
</script>